import { Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

export const LanguageMenuStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: "5rem",
      color: theme.palette.background.default
    },
    overrides: {
      MuiButton: {
        raisedPrimary: {
          color: "white"
        }
      }
    }
  })
);
